import React, { useState, useContext, useMemo } from "react";
import SearchInput from "../searchInput/SearchInput";
import RRDistribuciones from "../renderRows/RRDistribuciones";
import windowSizeContext from "../../context/windowSize/windowSizeContext";
import './DistribucionList.css';

function DistribucionList({ distribucionesConSubcuentas = [] }) {

    const [filter, setFilter] = useState("");

    const wSizeContext = useContext(windowSizeContext);
    const { height } = wSizeContext;

    const filteredItems = useMemo(() => {
        if (!filter) return distribucionesConSubcuentas;
        const f = filter.toLowerCase();
        return distribucionesConSubcuentas.filter(d =>
            (d.codDis || "").replace(/\s+/g, "").toLowerCase().includes(f) ||
            (d.codDisDescrp || "").toLowerCase().includes(f) ||
            (d.codDim || "").replace(/\s+/g, "").toLowerCase().includes(f) ||
            (d.codDimDescrp || "").toLowerCase().includes(f)
        );
    }, [distribucionesConSubcuentas, filter]);

    return (
        <div>
            <div style={{ marginLeft: "-150px" }}>
                <SearchInput defaultValue={filter} buscar={setFilter} />
            </div>
            <div className='distribucionesListDiv' style={{ height: height - 200, overflowY: 'scroll' }}>
                {filteredItems.map((item, index) => (
                    <RRDistribuciones
                        key={`${item.codDim}-${item.codDis}`}
                        item={item}
                        style={{}}
                    />
                ))}
            </div>
        </div>
    );
}

export default DistribucionList;
